import {V1_URL} from '../constants'

export const V1_SUPPLIER = `${V1_URL}/suppliers`

export const V1_SUPPLIER_BY_ID = (id) => `${V1_SUPPLIER}/${id}`

export const V1_EXPORT_SUPPLIER = `${V1_SUPPLIER}/export`



// WEBPACK FOOTER //
// ./app/api/inventory/suppliers/constants.js